module.exports = __webpack_public_path__ + "img/6.c16ca76a.png";